import { render, staticRenderFns } from "./guanqiaOldWinData.vue?vue&type=template&id=21d10a66&"
import script from "./guanqiaOldWinData.vue?vue&type=script&lang=js&"
export * from "./guanqiaOldWinData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d10a66')) {
      api.createRecord('21d10a66', component.options)
    } else {
      api.reload('21d10a66', component.options)
    }
    module.hot.accept("./guanqiaOldWinData.vue?vue&type=template&id=21d10a66&", function () {
      api.rerender('21d10a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/guanqia/guanqiaOldWinData.vue"
export default component.exports